import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { OPTION_LIST, FIELD_DANGER_CLASS_NAMES } from 'site-modules/dealerships/constants/dealer-review';
import { RadioList } from 'site-modules/shared/components/radio-list/radio-list';

export class DealerReviewOptionField extends Component {
  static propTypes = {
    legendTitle: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onOptionSelect: PropTypes.func.isRequired,
    value: PropTypes.string,
    showOptionErrors: PropTypes.bool,
  };

  static defaultProps = {
    showOptionErrors: false,
    value: null,
  };

  /**
   * Handles option select.
   * @param {String} value
   */
  selectOption = ({ target: { value } }) => {
    const { onOptionSelect, name } = this.props;
    onOptionSelect({ value, name });
  };

  render() {
    const { legendTitle, name, value, showOptionErrors } = this.props;
    const isError = showOptionErrors && !value;

    return (
      <Fragment>
        <RadioList
          legend={legendTitle}
          legendClassName="heading-5"
          name={name}
          labelClassName="ps-0_5 text-gray-darker"
          textClassName="ps-0_5 text-gray-darker"
          formClassName={classnames('mb-0', { 'has-danger': isError })}
          formGroupClassName="mb-1"
          list={OPTION_LIST}
          checked={value}
          onChange={this.selectOption}
        />
        {isError && <div className={classnames(FIELD_DANGER_CLASS_NAMES, 'mb-1_5')}>Please choose an option</div>}
      </Fragment>
    );
  }
}
